import React from "react";
import { Box, Divider } from "@mui/material";
import { WidgetMultiqueryPanelQuery } from "./WidgetMultiqueryPanelQuery";
import { TemplateQueryProps } from "components/widgets/utility/TemplateSearch/TemplateSearchContent";
import { currentUser } from "system/InfegyUser";

interface WidgetMultiqueryPanelOptions {
  queries?: TemplateQueryProps[];
  setQueries: (queries: TemplateQueryProps[]) => void;

  fixedDatasetId?: string;

  dashboardDatasetId?: string;

  isLoading?: boolean;
  setIsLoading?: (isLoading: boolean) => void;

  maxWidgetQueries: number;
}

export default function WidgetMultiqueryPanel(props: WidgetMultiqueryPanelOptions): JSX.Element {
  const user = currentUser();

  const { queries, fixedDatasetId, isLoading, setQueries } = props;

  return (
    <Box>
      {queries?.length && (
        <>
          {queries.map((query: TemplateQueryProps, index: number) => (
            <Box key={index} sx={{}}>
              <WidgetMultiqueryPanelQuery
                query={query}
                fixedDatasetId={fixedDatasetId}
                dashboardDatasetId={props.dashboardDatasetId}
                isLoading={isLoading}
                setIsLoading={props.setIsLoading}
                setQuery={(updatedQuery: TemplateQueryProps) => {
                  const updatedQueries = queries.slice();
                  updatedQueries[index] = updatedQuery;
                  setQueries(updatedQueries);
                }}
                onDelete={function (query: TemplateQueryProps): void {
                  const updatedQueries = queries.filter((q) => q !== query);
                  if (updatedQueries.length === 0) {
                    updatedQueries.push(new TemplateQueryProps(user));
                  }
                  setQueries(updatedQueries);
                }}
                />
              {index < queries.length - 1 && <Divider />}
            </Box>
          ))}
        </>
      )}
    </Box>
  );
}
